<template>
  <div class="distributor-box details_box_styles">
    <!--返回按钮-->
    <div class="go-back" style="display: inline-block" @click="goBackBtn">
      <Icon class="back-icon" type="ios-arrow-back"/>
      <span class="back-txt">{{ $t('key1002627') }}</span>
    </div>
    <!--步骤条-->
    <div class="stepBar_box">
      <Steps :current="progressStatus">
        <Step :title="$t('key1005981')" :content="$t('key1005982')" icon="md-checkmark-circle"></Step>
        <Step :title="$t('key1005983')" :content="$t('key1005984')" icon="md-checkmark-circle"></Step>
        <Step :title="$t('key1001489')" :content="$t('key1005985')" icon="md-checkmark-circle"></Step>
      </Steps>
    </div>
    <!--订单商品-->
    <div class="basic_information_box" v-show="progressStatus === 0">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1004421') }}</h2>
        </template>
        <div class="mb20">
          <Button type="primary" class="mr15" icon="md-add" @click="addProductBtn">{{ $t('key1001092') }}</Button>
          <Button icon="md-trash" :disabled="tableData.length<=0" @click="deleteProductBtn('all')">{{ $t('key1005966') }}</Button>
        </div>
        <Table
          ref="tableDom"
          :highlight-row="false"
          border
          max-height="400"
          :loading="tableLoading"
          :columns="tableColumns"
          :no-data-text="$t('key1005957')"
          @on-selection-change="getSelectValue"
          :data="tableData">
          <template #shippingWarehouse="{row, index}">
            <Select v-model="tableData[index].ymsWarehouseId" filterable style="width: 170px;"
              class="mt2 mb2" transfer @on-change="(value)=>selectChange(value, row, index)">
              <Option v-for="item in tableData[index].shippingWarehouseList" :disabled="item.availableNumber<=0"
                :value="item.ymsWarehouseId" :key="item.ymsWarehouseId" :label="item.name">
                <div class="flex align-items-center justify-content-between">
                  <span :class="item.availableNumber<=0 ? '' : 'color-333'">{{ item.name }}</span>
                  <span class="font-size-12 color-999">{{ '（' + $t('key1003367') + (item.availableNumber || 0) + '）' }}</span>
                </div>
              </Option>
            </Select>
          </template>
        </Table>
        <div class="flex total_goods_box">
          <div>
            <p class="mb10">
              <span class="money_item_style text-align-right">{{ $t('key1005969') }}</span>
              <span class="goods_num_style money_item_style">{{ totalQuantityGoods }}</span>
            </p>
            <p class="mb10">
              <span class="money_item_style text-align-right">{{ $t('key1005970') }}</span>
              <span class="goods_num_style money_item_style">{{ totalWeight }}</span>
            </p>
          </div>
          <div>
            <p class="mb10">
              <span class="money_item_style text-align-right">{{ $t('key1000119') }}</span>
              <span class="goods_num_style money_item_style">{{ currencyState + ' ' + formatCurrency(totalAmountGoods) }}</span>
            </p>
          </div>
        </div>
      </Card>
    </div>
    <!--收货地址-->
    <div class="basic_information_box" v-show="progressStatus === 0">
      <Card :bordered="false" dis-hover>
        <template #title><h2 class="title_box">{{ $t('key1005971') }}</h2></template>
        <Row type="flex" :gutter="gutterItem" v-if="Object.keys(receivingAddress).length>0">
          <Col :span="2" class="basic_item default_address_style">
            <span class="name_style" :title="receivingAddress.name">
              {{ receivingAddress.name }}
            </span>
            <i class="iconfont select_icon_style">&#xe8b7;</i>
          </Col>
          <Col :span="18" class="basic_item background_hover_style flex justify-content-center justify-content-between">
            <span class="basic_txt">{{ receivingAddress.detailedAddress }}</span>
            <div class="justify-content-center options_boxs">
               <span class="goods_num_style cursor mr15" v-if="receivingAddress.isDefault !==1 && getPermission('ymsDeliveryAddress_updateStatus')"
                 @click="setDefaultAddress(receivingAddress.ymsDeliveryAddressId)">{{ $t('key1005972') }}</span>
              <span class="goods_num_style cursor mr15" v-if="getPermission('ymsDeliveryAddress_update')" @click="setAddressBtn('edit', receivingAddress)">{{ $t('key1000985') }}</span>
              <span class="goods_num_style cursor" v-if="getPermission('delete_ymsDeliveryAddress')" @click="deleteAddressBtn(receivingAddress)">{{ $t('key1000105') }}</span>
            </div>
          </Col>
        </Row>
        <!--更多地址-->
        <div class="more_address_box" v-if="receivingAddressList.length>0">
          <h2 class="flex align-items-center cursor mb10" @click="moreAddressBtn">
            <span style="margin-right: 5px">{{ moreAddressTalg ? $t('key1005962') : $t('key1005963') }}</span>
            <Icon type="ios-arrow-down" :class="moreAddressTalg ? 'icon_rotate_style' : ''" size="20"/>
          </h2>
          <Row type="flex" :gutter="gutterItem" v-if="moreAddressTalg" class="more_address_list">
            <Col :span="18" class="basic_item background_hover_style flex justify-content-center justify-content-between cursor"
              v-for="(item, index) in receivingAddressList" :key="index">
              <div class="flex align-items-center" @click="selectAddress(item, index)">
                <div class="flex default_address_style" v-if="item.selectAddressTalg">
                  <span class="name_style pl20 pr20" :title="item.name">{{ item.name }}</span>
                  <i class="iconfont select_icon_style">&#xe8b7;</i>
                </div>
                <span class="basic_txt" v-else>{{ item.name }}</span>
                <span class="basic_txt pl20 pr20">{{ item.detailedAddress }}</span>
              </div>
              <div class="flex align-items-center options_boxs">
                <span class="goods_num_style cursor mr15" v-if="item.isDefault !==1 && getPermission('ymsDeliveryAddress_updateStatus')"
                  @click="setDefaultAddress(item.ymsDeliveryAddressId)">{{ $t('key1005972') }}</span>
                <span class="goods_num_style cursor mr15" v-if="getPermission('ymsDeliveryAddress_update')" @click="setAddressBtn('edit', item)">{{ $t('key1000985') }}</span>
                <span class="goods_num_style cursor" v-if="getPermission('delete_ymsDeliveryAddress')" @click="deleteAddressBtn(item)">{{ $t('key1000105') }}</span>
              </div>
            </Col>
          </Row>
        </div>
        <Button icon="md-add" v-if="getPermission('ymsDeliveryAddress_update')" @click="setAddressBtn('add')">{{ $t('key1001152') }}</Button>
      </Card>
    </div>
    <!--合规信息-->
    <div class="basic_information_box" v-if="progressStatus === 0 && relatedComplianceInfoData.length >0 && orderComplianceLabelVerificationTalg">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1005989') }}</h2>
        </template>
        <div class="wid100P mb20">
          <span class="font-size-14 color-333">
            {{ $t('key1005990') }}
            {{ $t('key1005991') }}
          </span>
          <span class="font-size-14 distributorThemeColor cursor" @click="redirectPage">{{ $t('key1005992') }}</span>
        </div>
        <div class="relatedComplianceInfo_box" v-for="ele in relatedComplianceInfoData">
          <div class="flex width_370 pr20">
            <div class="img_box">
              <img :src="ele.imgPath" alt="">
            </div>
            <div class="ml12" style="flex: 1;">
              <h2 class="font-size-14 color-333 font-weight-bold ellipsis_1" :title="ele.productName">{{ ele.productName }}</h2>
              <p>{{ configCharacters(false) + 'SPU：' + ele.ymsSpu }}</p>
              <p>{{ configCharacters(false) + 'SKU：' + ele.ymsSku }}</p>
              <p class="distributorThemeColor">{{ ele.specifications }}</p>
            </div>
          </div>
          <div style="flex:1">
            <!--责任人-->
            <div class="flex align-items-center mb15" v-for="item in responsibleAreaList.filter(j => j.zoneCode === receivingAddressZoneCode)">
              <span class="red-dot">{{ item.name + $t('key1005986') }}</span>
              <Select v-model="ele.selectYmsCompliancePersonId" filterable style="width: 280px;">
                <Option v-for="k in personInChargeList.filter(talg => talg.zoneCode === receivingAddressZoneCode)" :value="k.ymsCompliancePersonId">
                  {{ k.name }}
                </Option>
              </Select>
            </div>
            <!--制造商-->
            <div class="flex align-items-center">
              <span class="red-dot">{{ manufacturerName }}</span>
              <Select v-model="ele.selectYmsManufacturerInfoId" filterable style="width: 280px;">
                <Option v-for="k in manufacturerData" :value="k.ymsManufacturerInfoId">{{ k.name }}</Option>
              </Select>
            </div>
          </div>
        </div>
      </Card>
    </div>
    <!--订单物流选择-->
    <div class="basic_information_box" v-show="progressStatus === 1">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1005993') }}</h2>
        </template>
        <Collapse v-model="orderLogisticsCollapseList" class="orderLogisticsCollapse_box">
          <Panel :name="item.ymsWarehouseId + '_collapse'" v-for="(item,index) in orderLogisticsData" :key="item.ymsWarehouseId">
            <div
              class="flex align-items-center justify-content-between orderLogistics_header"
              style="width:98%;"
              @click.stop
              :ref="'orderLogisticsHeader_' + item.ymsWarehouseId"
            >
              <div class="flex align-items-center orderLogistics_summary">
                <span class="orderLogistics_orderNo distributorThemeColor">{{ $t('key1000124') + (index + 1) }}</span>
                <span
                  v-for="field in getOrderLogisticsVisibleFields(item, index)"
                  :key="field.key"
                  class="orderLogistics_field mr20"
                  :class="field.className"
                  :style="field.style"
                >{{ field.text }}</span>
                <Tooltip
                  v-if="getOrderLogisticsHiddenFields(item, index).length"
                  transfer
                  placement="top"
                  max-width="450"
                >
                  <template #content>
                    <p
                      v-for="field in getOrderLogisticsHiddenFields(item, index)"
                      :key="field.key"
                      :style="field.style"
                    >{{ field.text }}</p>
                  </template>
                  <Icon
                    type="ios-more"
                    color="#FD5425"
                    class="orderLogistics_more_icon cursor"
                    size="24"
                    @click.stop
                  />
                </Tooltip>
              </div>
              <div
                class="flex align-items-center orderLogistics_actions"
                :ref="'orderLogisticsActions_' + item.ymsWarehouseId"
              >
                  <span class="distributorThemeColor cursor" @click.stop="deliveryMethodBtn(item)">
                    {{ item.carrierShippingMethodCode ? $t('key1000412') : $t('key1000407') }}
                  </span>
                <div class="flex align-items-center ml20 " v-if="item.showIoss">
                  <Icon v-if="Object.keys(item.iossConfig).length > 0" class="mr4" size="20" color="#20B759" type="ios-checkmark-circle"/>
                  <Icon v-else class="mr4" size="20" color="#EA0000" type="ios-close-circle"/>
                  <span class="distributorThemeColor cursor"
                    @click.stop="$refs['uploadIoss'].initUploadIossData(item, 'ymsOrder', null)">{{ $t('key1005994') }}</span>
                </div>
              </div>
            </div>
            <template #content>
              <div class="orderLogistics_box" v-for="(ele,idx) in item.goodList">
                <!--商品-->
                <Col :span="8" style="display: flex" class="pr20">
                  <div class="orderLogistics_img_box">
                    <img :src="ele.imgPath" alt="">
                  </div>
                  <div class="ml12" style="flex: 1;">
                    <h2 class="font-size-14 color-333 font-weight-bold ellipsis_1" :title="ele.productName">{{ ele.productName }}</h2>
                    <p>{{ configCharacters(false) + 'SPU：' + ele.ymsSpu }}</p>
                    <p>{{ configCharacters(false) + 'SKU：' + ele.ymsSku }}</p>
                    <p class="distributorThemeColor">{{ ele.specifications }}</p>
                  </div>
                </Col>
                <!--数量-->
                <Col :span="3">
                  <span>{{ $t('key1005987') + ele.quantity }}</span>
                </Col>
                <!--单价-->
                <Col :span="4">
                  <span>{{ $t('key1004354') + formatCurrency(ele.suggestPrice) + ' ' + currencyState }}</span>
                </Col>
                <!--小计-->
                <Col :span="4">
                  <span>{{ $t('key1005988') + formatCurrency(ele.subtotal) + ' ' + currencyState }}</span>
                </Col>
                <!--发货仓-->
                <Col :span="5">
                  <span>{{ $t('key1001227') + item.shippingWarehouseName }}</span>
                </Col>
              </div>
            </template>
          </Panel>
        </Collapse>
      </Card>
    </div>
    <!--提交商品按钮操作栏-->
    <div class="submit_goods_box" :class="fixedTalg ? 'fixed_box_style': ''">
      <template v-if="progressStatus !==0">
        <span>{{ $t('key1001493') }}</span>
        <span class="goods_num_style" style="font-size: 18px;">{{ currencyState }} {{ formatCurrency(totalPayable) }}</span>
      </template>
      <Button size="large" class="mr15 ml30" @click="cancelOrderBtn">{{ $t('key1000112') }}</Button>
      <Button size="large" class="mr20" v-if="progressStatus >0" @click="previousStepBtn">{{ $t('key1000725') }}</Button>
      <Button size="large" :disabled="placeOrderTalg" type="primary" @click="placeOrderBtn">{{ progressText }}</Button>
    </div>
    <div style="visibility: hidden" :class="fixedTalg ? 'fixed_style' : ''"></div>
    <!--添加商品弹窗-->
    <addCommonProductModal
      ref="addCommonProduct"
      :apiUrl="apiUrl"
      :customStyle="true"
      systemType="distributor"
      :distributorShowFieldKeyList="['selection','goodsInfo','myInventory', 'supplierAvailableNumber', 'ymsAvailableNumber', 'suggestPrice', 'weight', 'length', 'status']"
      @updateGoodsData="updateGoodsData">
    </addCommonProductModal>
    <!--配送方式弹窗-->
    <distributionModeModal ref="distributionMode" :distributorEnableCarrierTalg="true" @updateDeliveryMethodData="updateDeliveryMethodData"></distributionModeModal>
    <!--收货地址弹窗-->
    <receivingAddressModal ref="receivingAddress" @updateAddress="updateAddress"></receivingAddressModal>
    <!--IOSS配置弹窗-->
    <uploadIossModal ref="uploadIoss" :receivingAddress="receivingAddress" @updateIossData="updateIossData"></uploadIossModal>
    <!--配置定制信息弹窗-->
    <configureCustomizedContentModal
      ref="configureCustomizedContent"
      @updateCustomInfoData="updateCustomInfoData">
    </configureCustomizedContentModal>
    <!--订单提交弹窗-->
    <orderSubmissionModal ref="orderSubmission" @updateOrderData="updateOrderData"></orderSubmissionModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import addCommonProductModal from "@/components/common/addCommonProductModal";
import distributionModeModal from "@/components/common/distributionModeModal.vue";
import receivingAddressModal from "@/components/common/receivingAddressModal.vue";
import {
  amountHandel, batchAllWarehouseData, getAllManufacturerData, getAllPersonInChargeData, getCountryZoneData,
  getIossTaxRateData, getProductShippingWarehouseInventory, getReceivingAddressData, getTrialGoodsPrice,
  getTrialPrice, commonLocalStorage
} from "@/utils/common";
import uploadIossModal from "@/views/distributor/components/orderManage/components/uploadIossModal.vue";
import configureCustomizedContentModal from "@/components/common/configureCustomizedContentModal.vue";
import {getAppClientHeight, getAppScrollContainer, getAppScrollHeight, getAppScrollTop} from "@/utils/appScroll";
import orderSubmissionModal from "@/components/common/orderSubmissionModal.vue";
import orderLogisticsSummaryOverflowMixin from "@/components/mixin/orderLogisticsSummaryOverflow_mixin";

export default {
  name: "addCloudSalesOrder",
  mixins: [Mixin, orderLogisticsSummaryOverflowMixin],
  data() {
    let v = this;
    return {
      apiUrl: api.post_ymsDistributorProductInfo_queryYmsProductGoods,
      ItemCol: 8,
      estimateFreightPrice: 0,
      placeOrderTalg: false,
      selectGoodsList: [],
      tableData: [],
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 310,
          key: 'productInfo',
          align: 'left',
          render(h, params) {
            let ymsSpu = params.row.ymsSpu;
            let productName = params.row.productName;
            let imgPath = params.row.imgPath;
            let list = [
              v.tableImg(h, params, 'primaryImage', imgPath),
              h('div', {
                class: 'text-align-left pl10'
              }, [
                h('Alink', {
                  props: {
                    AlinkShow: false,
                    linkName: productName,
                    textAlign: 'left',
                    className: 'mb5',
                    AlinkClass: 'ellipsis_2'
                  }
                }),
                h('p', {class: 'flex align-items-center'}, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000689')),
                  h('Alink', {
                    props: {
                      AlinkShow: false,
                      linkName: ymsSpu,
                      textAlign: 'left',
                      AlinkClass: 'distributorThemeColor'
                    }
                  })
                ]),
              ])
            ];
            return h('div', {
              class: 'flex ptb10',
            }, list)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          minWidth: 150,
          key: 'skuInfo',
          align: 'left',
          render: (h, params) => {
            let ymsSku = params.row.ymsSku;
            let specifications = params.row.specifications;
            return h('div', [
              h('p', {class: 'mt2 mb2'}, ymsSku),
              h('p', {class: 'mt2 mb2 color-green'}, specifications)
            ])
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001342'),
          key: 'shippingWarehouse',
          minWidth: 200,
          align: 'left',
          slot: 'shippingWarehouse',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000890'),
          key: 'supplierAvailableNumber',
          minWidth: 90,
          align: 'left',
          render(h, params) {
            let number = params.row.availableNumber || 0;
            return h('span', v.formatCurrency(number, 0))
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001110'),
          key: 'suggestPrice',
          minWidth: 130,
          align: 'left',
          render: (h, params) => {
            let suggestPrice = params.row.suggestPrice || 0;
            return h('div', {class: 'flex align-items-center'}, [
              h('div', {class: 'mr5'}, v.currencyState),
              h('div', v.formatCurrency(suggestPrice)),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005944'),
          key: 'quantity',
          minWidth: 200,
          align: 'left',
          render: (h, params) => {
            let availableNumber = params.row.availableNumber;
            let quantity = params.row.quantity;
            return h('div', [
              h('InputNumber', {
                props: {
                  controlsOutside: true,
                  value: quantity,
                  min: 1,
                  max: availableNumber,
                  activeChange: false,
                  formatter: value => `${parseInt(value)}`
                },
                style: {
                  width: '160px',
                  textAlign: 'left',
                  fontSize: '12px'
                },
                on: {
                  'on-change': num => {
                    if (num > 0) {
                      let weight = parseInt(num) * params.row.weight;
                      v.$set(v.tableData[params.index], 'commodityWeight', weight);
                      v.$set(v.tableData[params.index], 'quantity', parseInt(num));
                      setTimeout(() => {
                        v.getCommodityPrice(v.tableData, 'update');
                      }, 800);
                    }
                  }
                }
              })
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005945'),
          key: 'subtotal',
          minWidth: 140,
          align: 'left',
          render: (h, params) => {
            let subtotal = params.row.suggestPrice * parseInt(params.row.quantity);
            let total = v.formatCurrency(subtotal);
            v.$set(v.tableData[params.index], 'subtotal', subtotal);
            return h('div', {class: 'flex align-items-center'}, [
              h('div', {class: 'mr5'}, v.currencyState),
              h('div', total),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'left',
          width: 120,
          fixed: 'right',
          render: (h, params) => {
            let isSupportCustomization = params.row.isSupportCustomization;
            let configureCustomizedInfo = params.row.configureCustomizedInfo || {};
            let vestMerchantId = params.row.vestMerchantId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000003'),
                    show: isSupportCustomization === 1 && vestMerchantId !== v.userInfo.merchantId,
                    color: '#2D8CF0',
                    clickFn: () => {
                      let {configureCustomizedInfo, ...obj} = params.row;
                      obj.configureCustomizedInfo = {};
                      v.tableData.push(obj);
                      v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000002'));
                    }
                  },
                  {
                    show: isSupportCustomization === 1 && vestMerchantId !== v.userInfo.merchantId,
                    customRender: true, // 开启自定义内容的render函数
                    renderCustomContent: (h) => {
                      return h('div', {class: 'flex align-items-center justify-content-center'}, [
                        Object.keys(configureCustomizedInfo).length > 0 ? h('Icon', {
                          props: {
                            type: 'ios-checkmark-circle-outline',
                            size: 18,
                            color: '#0FE316'
                          },
                          style: {position: 'relative', top: '-1px'}
                        }) : '',
                        Object.keys(configureCustomizedInfo).length <= 0 ? h('Icon', {
                          props: {
                            type: 'ios-alert-outline',
                            size: 18,
                            color: '#FF9B06'
                          },
                          style: {position: 'relative', top: '-1px'}
                        }) : '',
                        h('span', {
                          class: 'cursor themeColor',
                          on: {
                            click() {
                              v.$refs['configureCustomizedContent'].initConfigureCustomizedContentData(
                                'createAHandmadeOrder', params.row, params.index)
                            }
                          }
                        }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001183'))
                      ])
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    color: '#FF0000',
                    show: true,
                    clickFn: () => {
                      v.deleteProductBtn('single', params.index);
                    }
                  },

                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      processingFee: 0, // 处理费
      totalPayable: 0, // 应付总额
      totalAmountGoods: 0, // 商品总金额
      distributionMode: {}, // 配送方式信息
      receivingAddress: {}, // 收货地址
      moreAddressTalg: false,
      receivingAddressList: [],
      totalWeight: 0, // 商品总重量
      totalQuantityGoods: 0, //商品的总数量
      fixedTalg: true,
      iossTaxRateList: [],
      progressStatus: 0,
      orderLogisticsCollapseList: [],
      orderLogisticsData: [],
      updateDataTalg: true,
      responsibleAreaList: [],
      relatedComplianceInfoData: [],
      personInChargeList: [],
      manufacturerData: [],
    }
  },
  computed: {
    progressText() {
      return this.progressStatus === 0 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002560') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000367');
    },
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 判断收货地址是否是欧盟、土耳其
    receivingAddressZoneCode() {
      let zoneCode = null;
      let {countryCode} = this.receivingAddress;
      if (countryCode) {
        this.responsibleAreaList.map((item) => {
          if (item.countries.includes(countryCode)) {
            zoneCode = item.zoneCode;
          }
        })
      }
      return zoneCode;
    },
    manufacturerName() {
      let name = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000282');
      let manufacturerName = '';
      this.responsibleAreaList.map((item) => {
        if (item.zoneCode === this.receivingAddressZoneCode) {
          manufacturerName = item.name;
        }
      })
      return manufacturerName + name;
    },
    // 订单合规标签校验配置项是否开启
    orderComplianceLabelVerificationTalg() {
      const saasConfigurationItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(saasConfigurationItems?.orderComplianceLabelVerificationSaas) === 1;
    },
  },
  mounted() {
    getAppScrollContainer().addEventListener('scroll', this.scrollBottom);
  },
  created() {
    this.initFun();
    this.getReceivingAddressList();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      (async () => {
        await getIossTaxRateData('distributor').then((newData) => {
          v.iossTaxRateList = newData;
        });
        await getAllPersonInChargeData().then((data) => {
          v.personInChargeList = data;
        });
        await getAllManufacturerData().then((data) => {
          v.manufacturerData = data;
        });
        await getCountryZoneData().then((data) => {
          v.responsibleAreaList = data;
        });
      })();
    },
    // 返回列表
    goBackBtn() {
      this.$router.push('/myOrder');
    },
    // 添加商品
    addProductBtn() {
      this.$refs['addCommonProduct'].initFun();
      this.$refs['addCommonProduct'].selectTableData = [];
      this.$refs['addCommonProduct'].total = 0;
    },
    // 删除商品
    deleteProductBtn(type, currentIndex) {
      let v = this;
      let new_arr = [];
      if (type === 'all') {
        if (v.selectGoodsList.length > 0) {
          let sortNoList = v.selectGoodsList.map((item) => item.sortNo);
          new_arr = v.tableData.filter((item, index) => {
            return !sortNoList.includes(index)
          });
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005948'));
          return false;
        }
        v.selectGoodsList = [];
      }
      // 单个删除，是按照sku维度删除
      else {
        new_arr = v.tableData.filter((item, index) => {
          return index !== currentIndex
        });
      }
      if (new_arr.length > 0) {
        v.tableData = JSON.parse(JSON.stringify(new_arr));
        v.updateTableDom('tableDom', 1000, false);
        if (v.tableData.length > 0) {
          v.updateDataTalg = false;
          setTimeout(() => {
            v.updateGoodsData(v.tableData, 'update');
          }, 500);
        }
      } else {
        v.tableData = [];
      }
    },
    // 新增、编辑收货地址按钮
    setAddressBtn(type, data) {
      let receivingAddress = this.$refs.receivingAddress;
      if (type === 'add') {
        receivingAddress.receivingAddressTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001152');
        if (this.receivingAddressList.length <= 0) {
          receivingAddress.receivingAddressForm.isDefault = 1;
          receivingAddress.defaultTalg = true;
        }
      } else {
        let newData = JSON.parse(JSON.stringify(data));
        receivingAddress.receivingAddressTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005949');
        receivingAddress.receivingAddressForm = newData;
        receivingAddress.receivingAddressForm.mobile = newData.mobile.split('+' + newData.mobileAreaCode + ' ')[1];
        receivingAddress.receivingAddressForm.phone = newData.phone.split('+' + newData.phoneAreaCode + ' ')[1];
      }
      receivingAddress.addressStatus = type;
      receivingAddress.receivingAddressModal = true;
    },
    // 删除收货地址
    deleteAddressBtn(data) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005950'),
        onOk: () => {
          v.axios.delete(api.delete_ymsDeliveryAddress + `${data.ymsDeliveryAddressId}`,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              v.getReceivingAddressList();
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 选择发货仓
    selectChange(value, obj, index) {
      let v = this;
      let shippingWarehouseList = obj.shippingWarehouseList || [];
      let availableNumber = shippingWarehouseList.filter((ele) => ele.ymsWarehouseId === value)[0].availableNumber;
      if (obj.quantity > availableNumber) {
        v.$set(v.tableData[index], 'quantity', availableNumber);
      }
      v.$set(v.tableData[index], 'availableNumber', availableNumber);
      setTimeout(() => {
        v.getCommodityPrice(v.tableData, 'update');
      }, 800);
    },
    // 勾选列表数据
    getSelectValue(value) {
      this.selectGoodsList = value;
    },
    // 更多地址
    moreAddressBtn() {
      this.moreAddressTalg = !this.moreAddressTalg;
    },
    // 设置默认的收货地址
    setDefaultAddress(ymsDeliveryAddressId, value) {
      let v = this;
      v.axios.put(api.put_ymsDeliveryAddress_updateStatus + `${ymsDeliveryAddressId}`).then(response => {
        if (response.data.code === 0) {
          if (!value) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          }
          v.getReceivingAddressList();
        }
      });
    },
    // 获取收货地址列表数据
    getReceivingAddressList() {
      let v = this;
      v.receivingAddress = {};
      v.receivingAddressList = [];
      this.handerMenuStyle(true);
      getReceivingAddressData().then((data) => {
        data.map((item) => {
          if (item.isDefault === 1) {
            v.receivingAddress = item;
            v.receivingAddress.detailedAddress = v.handerAddress(item);
          }
          item['detailedAddress'] = v.handerAddress(item);
          item['selectAddressTalg'] = false;
        });
        // 默认地址
        if (Object.keys(v.receivingAddress).length <= 0) {
          v.setDefaultAddress(data[0].ymsDeliveryAddressId, true);
        }
        v.receivingAddressList = data;
      });
    },
    // 详细地址的处理
    handerAddress(data) {
      let privacyMobile = data.mobile.replace(/(\d{3})\d*(\d{4})/, "$1****$2");
      return data.name + ' ' + data.state + ' ' + data.city + ' ' + data.county + ' ' + data.streetAddress + ' ' + privacyMobile;
    },
    // 选中地址
    selectAddress(item, index) {
      this.receivingAddressList.map((item, idx) => {
        item['selectAddressTalg'] = false;
        if (idx === index) {
          this.receivingAddress = item;
          this.$set(this.receivingAddressList[index], 'selectAddressTalg', true);
          if (Object.keys(this.distributionMode).length > 0) {
            this.$refs.distributionMode.receivingAddress = item;
            this.$refs.distributionMode.handerData(this.distributionMode);
          }
          this.getCommodityPrice(this.tableData, 'update');
        }
      });
    },
    // 更新收货地址
    updateAddress() {
      this.getReceivingAddressList();
    },
    // 配送方式
    deliveryMethodBtn(item) {
      let type = item.carrierShippingMethodCode ? 'edit' : 'select';
      this.$refs['distributionMode'].initDistributionModeData(type, item, this.receivingAddress);
    },
    // 更新配送方式数据
    updateDeliveryMethodData(data) {
      this.orderLogisticsData.map((item) => {
        if (item.ymsWarehouseId === data.ymsWarehouseId) {
          item.deliveryMethodDetails = data;
          item.carrierShippingMethodName = data.name;
          item.carrierShippingMethodCode = data.code;
          let iossStatus = item.deliveryMethodDetails.iossStatus;
          let carrierMerchantType = item.deliveryMethodDetails.carrierMerchantType;
          item.showIoss = iossStatus === 1 && carrierMerchantType === 3; // 使用的是yms物流，并且需要收取清关费才能走ioss配置
        }
      });
      this.setPrice('single', data);
    },
    // 更新ioss配置
    updateIossData(data) {
      this.orderLogisticsData.map((item) => {
        if (item.ymsWarehouseId === data.ymsWarehouseId) {
          item.iossConfig = data;
        }
      });
      this.setPrice('single', data);
    },
    // 处理选中的商品数据
    updateGoodsData(data, type) {
      let productGoodsList = JSON.parse(JSON.stringify(data));
      if (productGoodsList.length > 0) {
        const ymsProductGoodsIds = productGoodsList.map(item => item.ymsProductGoodsId).filter(id => id);
        // 处理回显发货仓
        if (ymsProductGoodsIds.length > 0) {
          getProductShippingWarehouseInventory(ymsProductGoodsIds).then((data) => {
            if (data.length > 0) {
              productGoodsList.forEach(ele => {
                const matchedItem = data.find(item => item.ymsProductGoodsId === ele.ymsProductGoodsId);
                if (matchedItem) {
                  const list = matchedItem.productDeliverWarehouseResultBos || [];
                  let newList = list.sort((a, b) => b.availableNumber - a.availableNumber);
                  newList.map((talg) => {
                    if (talg.ymsWarehouseId === ele.ymsWarehouseId) {
                      ele.availableNumber = talg.availableNumber;
                    }
                  });
                  ele.shippingWarehouseList = newList;
                  if (!ele.ymsWarehouseId) {
                    let ymsNewList = newList.filter((talg) => talg.servicePlatform === 'core' && talg.availableNumber > 0);
                    let supplierNewList = newList.filter((talg) => talg.servicePlatform === 'supplier' && talg.availableNumber > 0);
                    let list = ymsNewList.length > 0 ? ymsNewList : supplierNewList;
                    if (list.length > 0) {
                      ele.availableNumber = list[0].availableNumber || 0;
                      ele.ymsWarehouseId = list[0].availableNumber > 0 ? list[0].ymsWarehouseId : null;
                    }
                  }
                }
              });
              productGoodsList.map((item, index) => {
                item.sortNo = index;
                if (!item.shippingWarehouseList) {
                  item.shippingWarehouseList = [];
                }
                if (!item.ymsWarehouseId) {
                  item.ymsWarehouseId = null;
                }
                if (!item.configureCustomizedInfo) {
                  item.configureCustomizedInfo = {};
                }
                item['commodityWeight'] = item.weight * item.quantity;
                item.imgPath = '';
                item.productName = '';
                item.ymsProductGoodsPositions = [];
                item.isSupportCustomization = 0;
                let specificationsList = [];
                if (item._productInfo) {
                  let skuImgPath = item._productInfo.primaryImage;
                  let spuImgPath = item._productInfo._spuInfo.primaryImage
                  item.imgPath = skuImgPath ? skuImgPath : spuImgPath;
                  item.productName = item._productInfo._spuInfo.name;
                  item.isSupportCustomization = item._productInfo._spuInfo.isSupportCustomization; // 商品定制   1是  0否
                  item.ymsProductGoodsPositions = item._productInfo.ymsProductGoodsPositions || []; // 商品定制部位下拉数据
                  let productGoodsSpecifications = item._productInfo.productGoodsSpecificationList || [];
                  if (productGoodsSpecifications.length > 0) {
                    specificationsList = productGoodsSpecifications.map((item) => {
                      return item.value
                    });
                  }
                  item.isCustomization = item._productInfo?.isCustomization || 0;
                  item.specifications = specificationsList.join(' • ');
                }
              });
              if (type !== 'update') {
                this.handleUpdateData(productGoodsList);
              } else {
                this.handleTableData(productGoodsList);
              }
            }
          });
        }
      }
    },
    // 处理列表数据
    handleTableData(newList) {
      let v = this;
      setTimeout(() => {
        v.getCommodityPrice(newList, 'update');
      }, 1000);
    },
    // 处理普通商品根据ymsSku合并数据累加quantity
    handleUpdateData(productGoodsList) {
      let newData = [...this.tableData, ...productGoodsList];
      const arr1 = newData.filter(item => item.isSupportCustomization !== 1 ||
        (item.isSupportCustomization == 1 && item.vestMerchantId === this.userInfo.merchantId));
      const arr2 = newData.filter(item => item.isSupportCustomization === 1 && item.vestMerchantId !== this.userInfo.merchantId);
      let list = [];
      if (arr1.length > 0) {
        list = arr1.reduce((acc, current) => {
          const existing = acc.find(item => item.ymsSku === current.ymsSku);
          if (existing) {
            existing.quantity += current.quantity;
          } else {
            acc.push({...current});
          }
          return acc;
        }, []);
      }
      let newList = [...arr2, ...list];
      this.handleTableData(newList);
    },
    // 获取当前商品在指定仓库下的价格
    getCommodityPrice(productGoodsList, value) {
      const v = this;
      v.placeOrderTalg = true;
      return new Promise((resolve) => {
        let queryList = [];
        productGoodsList.map((item) => {
          let obj = {};
          if (item.ymsWarehouseId) {
            let newYmsSku = null;
            let newYmsProductGoodsId = null;
            let isNeedCustomization = 0;
            let ymsPackageGoodsCustomizationBos = [];
            if (Object.keys(item.configureCustomizedInfo).length > 0) {
              isNeedCustomization = item.configureCustomizedInfo.isNeedCustomization;
              let {ymsProductGoods} = item.configureCustomizedInfo;
              let newList = [];
              if (ymsProductGoods) {
                newYmsSku = ymsProductGoods.ymsSku;
                newYmsProductGoodsId = ymsProductGoods.ymsProductGoodsId;
                let ymsProductGoodsSpecificationsList = ymsProductGoods.ymsProductGoodsSpecifications || [];
                ymsProductGoodsSpecificationsList.map((k) => {
                  let ymsProductGoodsSpecificationImagesList = k.ymsProductGoodsSpecificationImages || [];
                  ymsProductGoodsSpecificationImagesList.map((j) => {
                    newList.push(j)
                  })
                });
              }
              let newData = v.handerGrouping(newList, function (item) {
                return [item.parts];
              }, 'parts', 'data');
              newData.map((talg) => {
                let data = talg.data.map((p, idx) => {
                  return {
                    md5: p.md5,
                    path: p.path,
                    sortNo: idx,
                    type: p.imageType
                  }
                })
                ymsPackageGoodsCustomizationBos.push({
                  parts: talg.parts,
                  ymsPackageGoodsCustomizationImageBos: data
                })
              })
            }
            if (isNeedCustomization === 1) {
              obj = {
                priceTrialGoodsBoList: [{
                  quantity: item.quantity,
                  ymsSku: newYmsSku,
                  originalYmsSku: item.ymsSku,
                  originalYmsProductGoodsId: item.ymsProductGoodsId,
                  ymsProductGoodsId: newYmsProductGoodsId,
                  isNeedCustomization: isNeedCustomization,
                  isCustomization: item.isCustomization,
                  ymsPackageGoodsCustomizationBos: ymsPackageGoodsCustomizationBos
                }],
                ymsDistributorMerchantId: v.userInfo.merchantId,
                warehouseIds: [item.ymsWarehouseId]
              }
            } else {
              obj = {
                priceTrialGoodsBoList: [{
                  quantity: item.quantity,
                  ymsProductGoodsId: item.ymsProductGoodsId,
                  isNeedCustomization: isNeedCustomization,
                  isCustomization: item.isCustomization,
                }],
                ymsDistributorMerchantId: v.userInfo.merchantId,
                warehouseIds: [item.ymsWarehouseId]
              }
            }
            // 是否展示合规信息
            let shippingWarehouseList = item.shippingWarehouseList || [];
            let countryCode = null;
            shippingWarehouseList.map((ele) => {
              if (ele.ymsWarehouseId === item.ymsWarehouseId) {
                let ymsWarehouseAddress = ele.ymsWarehouseAddress || [];
                ymsWarehouseAddress.map((k) => {
                  if (k.addressType === 'sender') {
                    countryCode = k.countryCode;
                  }
                })
              }
            });
            item.isShowComplianceInfoTalg = false;
            if (this.receivingAddressZoneCode) {
              this.responsibleAreaList.map((ele) => {
                if (ele.zoneCode === this.receivingAddressZoneCode) {
                  if (!ele.countries.includes(countryCode)) {
                    item.isShowComplianceInfoTalg = true;
                  }
                }
              })
            }
            queryList.push(obj);
          }
        });
        const handleData = (goodsList) => {
          if (value === 'update') {
            v.optionBtnWidth = [];
            v.tableData = goodsList;
            v.updateTableDom('tableDom', 1000, false);
            setTimeout(() => {
              v.updateTableDom('tableDom', 1000, false);
            }, 2000)
          }
          v.getComplianceData(goodsList);
          v.placeOrderTalg = false;
          resolve(goodsList);
        }
        if (queryList.length > 0) {
          if (v.updateDataTalg) {
            getTrialGoodsPrice({productGoodsList, queryList}).then((goodsList) => {
              handleData(goodsList)
            });
          } else {
            setTimeout(() => {
              v.updateDataTalg = true;
            }, 1000);
          }
        } else {
          handleData(productGoodsList);
        }
      });
    },
    // 获取合规信息的数据
    getComplianceData(productGoodsList) {
      this.relatedComplianceInfoData = [];
      if (productGoodsList.length > 0) {
        let newList = productGoodsList.filter((item) => {
          return item.isShowComplianceInfoTalg === true;
        });
        if (newList.length > 0) {
          newList.forEach(item => {
            const spuInfo = item._productInfo && item._productInfo._spuInfo;
            const compliancePersonProductList = Array.isArray(spuInfo?.compliancePersonProductList)
              ? spuInfo.compliancePersonProductList : [];
            const ymsManufacturerInfoProductList = Array.isArray(spuInfo?.ymsManufacturerInfoProductList)
              ? spuInfo.ymsManufacturerInfoProductList : [];
            // 负责人
            let ymsProductId = item.ymsProductId || spuInfo.ymsProductId;
            const compliance = compliancePersonProductList.find(
              ele => ele.ymsProductId === ymsProductId && ele.zoneCode === this.receivingAddressZoneCode);
            item.selectYmsCompliancePersonId = compliance
              ? compliance.ymsCompliancePersonId : item.selectYmsCompliancePersonId || null;

            // 制造商
            const manufacturer = ymsManufacturerInfoProductList.find(
              ele => ele.ymsProductId === ymsProductId && ele.zoneCode === this.receivingAddressZoneCode);
            item.selectYmsManufacturerInfoId = manufacturer
              ? manufacturer.ymsManufacturerInfoId : item.selectYmsManufacturerInfoId || null;
          });
          this.relatedComplianceInfoData = newList;
        }
      }
    },
    // 取消订单
    cancelOrderBtn() {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005951'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005952'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005953'),
        onOk: () => {
          v.goBackBtn();
        },
        onCancel: () => {
        }
      });
    },
    // 上一步
    previousStepBtn() {
      let v = this;
      v.progressStatus = 0;
      if (v.tableData.length > 0) {
        v.updateDataTalg = true;
        setTimeout(() => {
          v.updateGoodsData(v.tableData, 'update');
        }, 1500);
      }
    },
    // 提交订单
    placeOrderBtn() {
      let v = this;
      switch (v.progressStatus) {
        // 下一步
        case 0:
          if (v.tableData.length > 0) {
            // 校验定制商品信息
            let customizedProductInfoTalg = true;
            let customizedProductInfoList = v.tableData.filter((item) => item.isSupportCustomization === 1 && item.vestMerchantId !== v.userInfo.merchantId);
            if (customizedProductInfoList.length > 0) {
              customizedProductInfoTalg = customizedProductInfoList.every((item) => Object.keys(item.configureCustomizedInfo).length > 0);
            }
            if (!customizedProductInfoTalg) {
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000704'));
              return false;
            }
            // 校验合规信息
            if (v.orderComplianceLabelVerificationTalg) {
              let relatedComplianceTalg = true;
              if (v.relatedComplianceInfoData.length > 0) {
                relatedComplianceTalg = v.relatedComplianceInfoData.every((item) => {
                  return item.selectYmsCompliancePersonId && item.selectYmsManufacturerInfoId;
                });
              }
              if (relatedComplianceTalg) {
                if (v.relatedComplianceInfoData.length > 0) {
                  v.tableData.map((item) => {
                    item.ymsCompliancePersonProductBos = [];
                    item.insertYmsManufacturerInfoProductBos = [];
                    v.relatedComplianceInfoData.map((ele) => {
                      if (item.ymsProductId === ele.ymsProductId) {
                        // 责任人
                        item.ymsCompliancePersonProductBos.push({
                          ymsCompliancePersonId: ele.selectYmsCompliancePersonId,
                          ymsDistributorMerchantId: v.userInfo.merchantId,
                          ymsProductId: ele.ymsProductId,
                          zoneCode: v.receivingAddressZoneCode
                        });
                        // 制造商
                        item.insertYmsManufacturerInfoProductBos.push({
                          ymsManufacturerInfoId: ele.selectYmsManufacturerInfoId,
                          ymsDistributorMerchantId: v.userInfo.merchantId,
                          ymsProductId: ele.ymsProductId,
                          zoneCode: v.receivingAddressZoneCode
                        });
                      }
                    });
                  })
                }
              } else {
                v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005974'));
                return false;
              }
            }
            let talg = v.tableData.every((item) => item.ymsWarehouseId && item.quantity);
            if (talg) {
              if (Object.keys(v.receivingAddress).length > 0) {
                v.orderLogisticsData = [];
                let newList = [];
                let newData = JSON.parse(JSON.stringify(v.tableData));
                const ymsWarehouseIds = newData.map(item => item.ymsWarehouseId).filter(Boolean);
                if (!ymsWarehouseIds.length) {
                  handleData(newData);
                  return;
                }
                batchAllWarehouseData(ymsWarehouseIds).then(warehouseData => {
                  const warehouseMap = {};
                  warehouseData.forEach(warehouse => {
                    warehouseMap[warehouse.ymsWarehouseId] = warehouse.name;
                  });
                  newList = newData.map(item => ({
                    ...item,
                    shippingWarehouseName: warehouseMap[item.ymsWarehouseId] || ''
                  }));
                  handleData(newList);
                });
              } else {
                v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005975'));
                return false;
              }
            } else {
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005976'));
              return false;
            }
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005977'));
            return false;
          }

        function handleData(newList) {
          let keyList = ['ymsWarehouseId', 'shippingWarehouseName', 'totalOrderAmount', 'totalAmountOfGoods', 'iossConfig', 'showIoss',
            'processingFee', 'shippingFee', 'carrierShippingMethodName', 'carrierShippingMethodCode', 'deliveryMethodDetails'];
          newList.map((item) => {
            item.totalOrderAmount = 0; // 订单总金额
            item.totalAmountOfGoods = 0; // 商品总金额
            item.processingFee = 0; // 处理费
            item.shippingFee = 0; // 运费
            item.carrierShippingMethodName = ''; // 物流渠道名称
            item.carrierShippingMethodCode = ''; // 物流方案代码
            item.deliveryMethodDetails = {}; // 配送方式
            item.iossConfig = {}; // ioss配置
            item.showIoss = false; // 是否展示ioss配置
          });
          let destinationCountryTalg = v.iossTaxRateList.some((item) => {
            return item.countryCode === v.receivingAddress.countryCode;
          });
          let list = v.handerGrouping(newList, function (item) {
            return [item.ymsWarehouseId];
          }, keyList, 'goodList');
          list.map((item) => {
            item.totalAmountOfGoods = item.goodList.reduce((sum, good) => {
              return sum + (good.subtotal || 0);
            }, 0);
            item.totalOrderAmount = item.processingFee + item.shippingFee + item.totalAmountOfGoods;
            /*item.showIoss = destinationCountryTalg;*/ // TE-32196  bug临时调整
          });
          v.progressStatus = 1;
          v.orderLogisticsData = list;
          let key = list[0].ymsWarehouseId + '_collapse';
          v.orderLogisticsCollapseList = [key];
          v.setPrice('all');
        }

          break;
        // 提交
        case 1:
          let deliveryMethodTalg = v.orderLogisticsData.every((item) => {
            return Object.keys(item.deliveryMethodDetails).length > 0
          });
          if (!deliveryMethodTalg) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005978'));
            return false;
          }
          let iossConfigValid = v.orderLogisticsData.every(item => {
            if (item.showIoss === true) {
              return item.iossConfig && Object.keys(item.iossConfig).length > 0;
            }
            return true;
          });
          if (!iossConfigValid) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005979'));
            return false;
          }
          let query = {
            merchantId: v.userInfo.merchantId,
            ymsPackageInfos: []
          };
          v.orderLogisticsData.map((item) => {
            let {ymsWarehouseId, deliveryMethodDetails, showIoss, iossConfig, goodList} = item;
            let carrierMerchantType = deliveryMethodDetails.carrierMerchantType;
            let iossObj = {};
            if (showIoss) {
              iossObj = {
                iossLogisticCost: iossConfig.iossLogisticCost,
                iossNo: iossConfig.iossNo,
                iossType: iossConfig.iossType,
              }
            }
            let ymsCompliancePersonProductBosList = [];
            let insertYmsManufacturerInfoProductBosList = [];
            goodList.map((ele) => {
              if (ele.isShowComplianceInfoTalg && v.orderComplianceLabelVerificationTalg) {
                if (ele.ymsCompliancePersonProductBos.length > 0) {
                  ymsCompliancePersonProductBosList.push(...ele.ymsCompliancePersonProductBos)
                }
                if (ele.insertYmsManufacturerInfoProductBos.length > 0) {
                  insertYmsManufacturerInfoProductBosList.push(...ele.insertYmsManufacturerInfoProductBos)
                }
              }
            })
            // 处理组装定制商品的信息
            let ymsPackageGoodsList = v.processingCustomAssembledProducts(goodList);
            query.ymsPackageInfos.push({
              buyerAddress1: v.receivingAddress.streetAddress,
              buyerCity: v.receivingAddress.city,
              buyerCountryCode: v.receivingAddress.countryCode,
              buyerEmail: v.receivingAddress.email,
              buyerMobile: v.receivingAddress.mobile,
              buyerName: v.receivingAddress.name,
              buyerAccountId: v.receivingAddress.name,
              buyerPhone: v.receivingAddress.phone,
              buyerPostalCode: v.receivingAddress.postalCode,
              buyerState: v.receivingAddress.state,
              ...iossObj,
              carrierId: carrierMerchantType !== 3 ? deliveryMethodDetails.carrierId : null,
              shippingMethodId: carrierMerchantType !== 3 ? deliveryMethodDetails.shippingMethodId : null,
              ymsWarehouseId: ymsWarehouseId,
              carrierMerchantType: carrierMerchantType,
              ymsLogisServiceId: carrierMerchantType === 3 ? deliveryMethodDetails.ymsLogisServiceId : null,
              isNeedCustomization: goodList.some((k) => k.configureCustomizedInfo?.isNeedCustomization === 1) ? 1 : 0,
              ymsPackageGoods: ymsPackageGoodsList,
              ymsCompliancePersonProductBos: ymsCompliancePersonProductBosList,
              insertYmsManufacturerInfoProductBos: insertYmsManufacturerInfoProductBosList,
            });
          });
          let obj = {
            totalPrice: Number(v.totalPayable),
            currency: v.currencyState,
            params: {
              url: api.post_ymsPlatformOrder_createOrder,
              query
            },
          }
          v.$refs['orderSubmission'].initOrderSubmissionData(obj)
          break;
      }
    },
    // 下单成功，更新操作
    updateOrderData(obj) {
      let {data} = obj;
      let payStatus = data[0].payStatus;
      let text = payStatus === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488') : payStatus === 2 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005980') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155');
      this.$Message.success(text);
      this.goBackBtn();
    },
    // 处理组装定制商品的信息
    processingCustomAssembledProducts(goodList) {
      let v = this;
      let newData = goodList.map((ele) => {
        let newYmsSku = null;
        let newYmsProductGoodsId = null;
        let isNeedCustomization = 0;
        let ymsPackageGoodsCustomizationBos = [];
        if (Object.keys(ele.configureCustomizedInfo).length > 0) {
          let {ymsProductGoods} = ele.configureCustomizedInfo;
          let newList = [];
          if (ymsProductGoods) {
            newYmsSku = ymsProductGoods.ymsSku;
            newYmsProductGoodsId = ymsProductGoods.ymsProductGoodsId;
            isNeedCustomization = ele.configureCustomizedInfo.isNeedCustomization;
            let ymsProductGoodsSpecificationsList = ymsProductGoods.ymsProductGoodsSpecifications || [];
            ymsProductGoodsSpecificationsList.map((k) => {
              let ymsProductGoodsSpecificationImagesList = k.ymsProductGoodsSpecificationImages || [];
              ymsProductGoodsSpecificationImagesList.map((j) => {
                newList.push(j)
              })
            });
          }
          let newData = v.handerGrouping(newList, function (item) {
            return [item.parts];
          }, 'parts', 'data');
          newData.map((talg) => {
            let data = talg.data.map((p, idx) => {
              return {
                md5: p.md5,
                path: p.path,
                sortNo: idx,
                type: p.imageType
              }
            })
            ymsPackageGoodsCustomizationBos.push({
              parts: talg.parts,
              ymsPackageGoodsCustomizationImageBos: data
            })
          })
        }
        if (isNeedCustomization === 1 && ele.vestMerchantId !== v.userInfo.merchantId) {
          return {
            quantity: ele.quantity,
            ymsSku: newYmsSku, // 定制新生成ymsSku
            originalYmsSku: ele.ymsSku, // 原始ymsSku
            originalYmsProductGoodsId: ele.ymsProductGoodsId,
            ymsProductGoodsId: newYmsProductGoodsId,
            isNeedCustomization: isNeedCustomization,
            isCustomization: ele.isCustomization,
            ymsPackageGoodsCustomizationBos: ymsPackageGoodsCustomizationBos
          }
        } else {
          return {
            quantity: ele.quantity,
            ymsSku: ele.ymsSku,
            ymsProductGoodsId: ele.ymsProductGoodsId,
            isCustomization: ele.isCustomization,
            isNeedCustomization: isNeedCustomization,
          }
        }
      });
      // 根据ymsProductGoodsId 去重累加 quantity
      return Object.values(newData.reduce((acc, item) => {
        if (acc[item.ymsProductGoodsId]) {
          // 累加quantity
          acc[item.ymsProductGoodsId].quantity += item.quantity;
        } else {
          acc[item.ymsProductGoodsId] = {...item};
        }
        return acc;
      }, {}));
    },
    // 全部移除商品时，重置数据
    resetData() {
      this.selectGoodsList = [];
      this.processingFee = 0;
      this.totalPayable = 0;
      this.totalAmountGoods = 0;
      this.totalWeight = 0;
      this.totalQuantityGoods = 0;
      this.distributionMode = {};
    },
    // 监听是否滚动到底部
    scrollBottom() {
      let talg = 200;
      let v = this;
      if (!v.fixedTalg) {
        v.fixedTalg = true;
      }
      let scrollContainer = getAppScrollContainer();
      let scrollTop = getAppScrollTop(scrollContainer);
      let clientHeight = getAppClientHeight(scrollContainer);
      let scrollHeight = getAppScrollHeight(scrollContainer);
      if (scrollTop + clientHeight >= scrollHeight - talg) {
        v.fixedTalg = false;
      }
    },
    // 处理侧边栏菜单留白的问题
    handerMenuStyle(value) {
      let v = this;
      v.$nextTick(() => {
        let dom = [...document.querySelectorAll("div[id='distributorSidebarBox']")];
        if (dom && dom.length > 0) {
          dom[0].style.height = value ? 'initial' : '100vh';
        }
      });
    },
    // 获取试算价格
    setPrice(type, obj) {
      let v = this;
      v.placeOrderTalg = true;
      switch (type) {
        // 单个计算
        case 'single':
          let query = {};
          v.orderLogisticsData.map((item) => {
            let {ymsWarehouseId, deliveryMethodDetails, goodList} = item;
            if (ymsWarehouseId === obj.ymsWarehouseId) {
              let priceTrialGoodsBoList = v.processingCustomAssembledProducts(goodList);
              let carrierMerchantType = deliveryMethodDetails.carrierMerchantType;
              if (priceTrialGoodsBoList.length > 0) {
                query = {
                  countryCode: this.receivingAddress.countryCode,
                  priceTrialGoodsBoList: priceTrialGoodsBoList,
                  shippingMethodId: carrierMerchantType === 3 ? null : deliveryMethodDetails.shippingMethodId,
                  ymsDistributorMerchantId: this.userInfo.merchantId,
                  ymsLogisServiceId: carrierMerchantType === 3 ? deliveryMethodDetails.ymsLogisServiceId : null,
                  buyerPostalCode: this.receivingAddress.postalCode,
                  carrierMerchantType: carrierMerchantType,
                  carrierMerchantId: carrierMerchantType === 1 ? deliveryMethodDetails.merchantId : null,
                  warehouseIds: [ymsWarehouseId],
                }
              }
            }
          });
          if (Object.keys(query).length > 0) {
            setTimeout(() => {
              getTrialPrice(query).then((newData) => {
                v.placeOrderTalg = false;
                if (newData.length > 0) {
                  v.orderLogisticsData.map((item) => {
                    newData.map((ele) => {
                      if (item.ymsWarehouseId === ele.warehouseId) {
                        item.totalOrderAmount = amountHandel(ele.totalPrice); // 订单总金额
                        item.totalAmountOfGoods = amountHandel(ele.goodsPrice); // 商品总金额
                        item.processingFee = amountHandel(ele.handlePrice); // 处理费
                        item.shippingFee = amountHandel(ele.estimateFreightPrice); // 运费
                      }
                    })
                  });
                  v.$forceUpdate();
                }
              })
            }, 800);
          }
          break;
        // 全部计算
        case 'all':
          let queryList = [];
          v.orderLogisticsData.map((item) => {
            let {ymsWarehouseId, deliveryMethodDetails, goodList} = item;
            let priceTrialGoodsBoList = v.processingCustomAssembledProducts(goodList);
            let carrierMerchantType = deliveryMethodDetails.carrierMerchantType;
            if (priceTrialGoodsBoList.length > 0) {
              queryList.push({
                countryCode: this.receivingAddress.countryCode,
                priceTrialGoodsBoList: priceTrialGoodsBoList,
                shippingMethodId: carrierMerchantType === 3 ? null : deliveryMethodDetails.shippingMethodId,
                ymsDistributorMerchantId: this.userInfo.merchantId,
                ymsLogisServiceId: carrierMerchantType === 3 ? deliveryMethodDetails.ymsLogisServiceId : null,
                buyerPostalCode: this.receivingAddress.postalCode,
                carrierMerchantType: carrierMerchantType,
                carrierMerchantId: carrierMerchantType === 1 ? deliveryMethodDetails.merchantId : null,
                warehouseIds: [ymsWarehouseId],
              });
            }
          });
          if (queryList.length > 0) {
            setTimeout(() => {
              getTrialGoodsPrice({
                productGoodsList: v.orderLogisticsData,
                queryList,
                original: true
              }).then((newData) => {
                v.orderLogisticsData.map((item) => {
                  newData.map((ele) => {
                    if (item.warehouseId === ele.ymsWarehouseId) {
                      item.totalOrderAmount = amountHandel(ele.totalPrice); // 订单总金额
                      item.totalAmountOfGoods = amountHandel(ele.goodsPrice); // 商品总金额
                      item.processingFee = amountHandel(ele.handlePrice); // 处理费
                      item.shippingFee = amountHandel(ele.estimateFreightPrice); // 运费
                    }
                  });
                });
                v.placeOrderTalg = false;
                v.$forceUpdate();
              });
            }, 800);
          }
          break;
      }
    },
    // 更新配置定制信息数据
    updateCustomInfoData(obj) {
      let v = this;
      let {currentIndex, isNeedCustomization, ...vals} = obj;
      let configureCustomizedInfo = {};
      if (isNeedCustomization === 1) {
        configureCustomizedInfo = {
          isNeedCustomization,
          ...vals
        }
      } else {
        configureCustomizedInfo = {
          isNeedCustomization: 0
        }
      }
      v.$set(v.tableData[currentIndex], 'configureCustomizedInfo', configureCustomizedInfo);
      setTimeout(() => {
        v.getCommodityPrice(v.tableData, 'update');
      }, 800);
      v.$forceUpdate();
    },
    // 跳转页面
    redirectPage() {
      const {href} = this.$router.resolve({
        path: '/complianceResponsiblePersonList'
      });
      window.open(href, '_blank');
    },
  },
  //页面离开后销毁监听事件
  destroyed() {
    this.handerMenuStyle(false);
    getAppScrollContainer().removeEventListener('scroll', this.scrollBottom);
  },
  watch: {
    // 监听商品数据
    tableData: {
      handler(data) {
        if (data.length > 0) {
          // 商品的总重量
          this.totalWeight = data.reduce((pre, cur) => {
            return pre + cur.commodityWeight;
          }, 0);
          // 商品总数量
          this.totalQuantityGoods = data.reduce((pre, cur) => {
            return pre + cur.quantity
          }, 0);
          // 商品总金额
          this.totalAmountGoods = data.reduce((pre, cur) => {
            return pre + cur.subtotal
          }, 0);
        } else {
          this.resetData();
        }
      },
      deep: true
    },
    // 监听订单物流选择
    orderLogisticsData: {
      handler(data) {
        if (data.length > 0) {
          // 应付总额
          this.totalPayable = data.reduce((pre, cur) => {
            return Number(pre) + Number(cur.totalOrderAmount);
          }, 0);
        }
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    orderSubmissionModal,
    configureCustomizedContentModal,
    uploadIossModal,
    addCommonProductModal,
    distributionModeModal,
    receivingAddressModal
  }
}
</script>

<style lang="less" scoped>
.details_box_styles {
  .total_goods_box {
    margin: 30px 115px 20px 0;
    justify-content: flex-end;
  }

  .money_item_style {
    display: inline-block;
    min-width: 120px;
  }

  .goods_num_style {
    color: #FD5425;
    font-weight: bold;
    font-size: 14px;
    min-width: 94px;
  }

  .submit_goods_box {
    width: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 10px 90px 10px 0;
    margin-bottom: 12px;
  }

  .fixed_box_style {
    position: fixed;
    z-index: 1000;
    left: 0;
    bottom: 0;
    margin-bottom: 0;
    box-shadow: 0px -3px 10px 0px #c9cbce;
  }

  .fixed_style {
    height: 60px;
    margin-bottom: 12px;
  }

  .stepBar_box {
    padding: 15px 100px;
    background-color: #fff;
    margin-bottom: 12px;

    /deep/ .ivu-steps {
      .ivu-steps-item {
        overflow: initial;
      }

      .ivu-steps-main {
        display: flex;
        flex-direction: column;
      }

      .ivu-steps-head {
        display: table-cell;
        padding-left: 0;
      }

      .ivu-steps-tail {
        left: 7px;
      }

      .ivu-steps-content {
        padding: 0;
      }
    }
  }

  .default_address_style {
    border: 2px solid #FD5425;
    box-sizing: border-box;
    text-align: center;
    height: 35px;
    line-height: 33px;
    position: relative;

    .name_style {
      display: inline-block;
      width: 100%;
      max-width: 110px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-wrap: break-word;
      word-break: break-all;
    }

    .select_icon_style {
      position: absolute;
      right: -1px;
      bottom: -5px;
      color: #FD5425;
      font-size: 29px;
    }
  }

  .background_hover_style {
    padding: 0 25px !important;

    .options_boxs {
      display: none;
    }

    .basic_txt {
      max-width: 900px !important;
    }

    &:hover {
      background-color: rgba(255, 83, 16, 0.0588235294117647);

      .options_boxs {
        display: flex;
      }
    }
  }

  .more_address_box {
    margin: 15px 0;

    .more_address_list {
      max-height: 350px;
      overflow-y: auto;
    }

    .icon_rotate_style {
      transform: translateY(0) rotate(180deg);
    }
  }

  /deep/ .orderLogisticsCollapse_box {
    border: none;
    background-color: transparent;

    .ivu-collapse-header {
      display: flex;
      padding: 10px 14px 10px 14px;
      background-color: #f7f7f7;
      min-height: auto;
      line-height: initial;

      .ivu-icon-ios-arrow-forward {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }

    .ivu-collapse-item {
      border: 1px solid #dcdee2;
      margin-bottom: 15px;
    }

    .orderLogistics_header {
      min-width: 0;
    }

    .orderLogistics_summary {
      flex: 1;
      min-width: 0;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
    }

    .orderLogistics_orderNo {
      flex-shrink: 0;
      margin-right: 20px;
    }

    .orderLogistics_field {
      flex-shrink: 0;
      white-space: nowrap;
    }

    .orderLogistics_more_icon {
      flex-shrink: 0;
      margin-left: 4px;
      position: relative;
      top: 2px;
    }

    .orderLogistics_actions {
      flex-shrink: 0;
      margin-left: 12px;
    }

    .orderLogistics_box {
      display: flex;
      align-items: flex-start;
      border-bottom: 1px solid #E2E2E2;
      padding-bottom: 15px;
      margin-bottom: 18px;

      .orderLogistics_img_box {
        width: 80px;
        height: 80px;
        position: relative;

        img {
          display: inline-block;
          left: 50%;
          max-height: 100%;
          max-width: 100%;
          position: absolute;
          top: 50%;
          transform: translateY(-50%) translateX(-50%);
        }
      }

      &:not(:last-child) {
        border-bottom: 1px solid #E2E2E2;
      }

      &:last-child {
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;
      }
    }
  }

  /deep/ .ivu-input-number-input {
    text-align: center;
  }

  /deep/ .ivu-input-number-controls-outside-btn-disabled {
    background-color: #f3f3f3 !important;

    i {
      color: #ccc !important;
    }
  }

  .relatedComplianceInfo_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #E2E2E2;
    margin-bottom: 16px;
    padding-bottom: 16px;
    max-height: 400px;
    overflow-y: auto;

    .img_box {
      width: 80px;
      height: 80px;
      position: relative;

      img {
        display: inline-block;
        left: 50%;
        max-height: 100%;
        max-width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
      }
    }

    &:not(:last-child) {
      border-bottom: 1px solid #E2E2E2;
    }

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }
}

</style>
